import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsSchemaSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-schema-settings-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
